import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

const API_BASE = "/functions/trackapi";

const App = ({ handleLogout }) => {
  const [folders, setFolders] = useState([]);
  const [folder, setFolder] = useState("");
  const [files, setFiles] = useState([]);
  const [query, setQuery] = useState("");
  const [playingIndex, setPlayingIndex] = useState(-1);
  const [shuffle, setShuffle] = useState(false);
  const [queue, setQueue] = useState([]);
  const [history, setHistory] = useState([]); // stores previously played indexes
const nowPlayingRef = useRef(null);
const trackRef = useRef(null);
const [scrollTitle, setScrollTitle] = useState(false);

  const audioRef = useRef(null);

  /* -------------------------
     Initial load
  --------------------------*/
  useEffect(() => {
    fetchFolders();
  }, []);

  useEffect(() => {
  const checkOverflow = () => {
    if (!nowPlayingRef.current || !trackRef.current) return;

    const containerWidth = nowPlayingRef.current.offsetWidth;
    const textWidth = trackRef.current.scrollWidth / 2; // one copy only

    setScrollTitle(textWidth > containerWidth);
  };

  checkOverflow();
  window.addEventListener("resize", checkOverflow);

  return () => window.removeEventListener("resize", checkOverflow);
}, [playingIndex]);


  /* -------------------------
     API calls
  --------------------------*/
  async function fetchFolders() {
    try {
      const res = await fetch(`${API_BASE}/folders.php`, {
        credentials: "include"
      });

  if (res.status === 401) {
    console.warn("Not authenticated");
    handleLogout(); // bounce user back to Google login
    return;
  }

      //const data = await res.json();
const text = await res.text();

const data = JSON.parse(text);
setFolders(data);

    } catch (err) {
      console.error("Failed to fetch folders:", err);
    }
  }

async function openFolder(f) {
  setFolder(f);
  setQuery('');
  const res = await fetch(`${API_BASE}/files.php?folder=${encodeURIComponent(f)}`);
  const js = await res.json();
  setFiles(js);
  setQueue(js);
  setPlayingIndex(-1);
}


  /* -------------------------
     Playback helpers
  --------------------------*/
  function filteredFiles() {
    if (!query) return files;
    return files.filter((f) =>
      f.toLowerCase().includes(query.toLowerCase())
    );
  }

 function playAt(index) {
  if (playingIndex !== -1) {
    setHistory((h) => [...h, playingIndex]);
  }

  setPlayingIndex(index);
  const filename = queue[index];
  const src = `${API_BASE}/stream.php?folder=${encodeURIComponent(folder)}&file=${encodeURIComponent(filename)}`;
  audioRef.current.src = src;
  audioRef.current.play();
}

function playPrevious() {
  if (history.length === 0) return;

  const prevIndex = history[history.length - 1];
  setHistory((h) => h.slice(0, -1));
  playAt(prevIndex);
}

function playNext() {
  if (queue.length === 0) return;

  let nextIndex;

  if (shuffle) {
    do {
      nextIndex = Math.floor(Math.random() * queue.length);
    } while (queue.length > 1 && nextIndex === playingIndex);
  } else {
    nextIndex = playingIndex + 1;
    if (nextIndex >= queue.length) return;
  }

  playAt(nextIndex);
}



  function handleFileClick(filteredIndex) {
    const filename = filteredFiles()[filteredIndex];
    const queueIndex = queue.indexOf(filename);
    if (queueIndex !== -1) playAt(queueIndex);
  }

 function onEnded() {
  playNext();
}

  function toggleShuffle() {
    setShuffle((s) => !s);
  }

  /* -------------------------
     Render
  --------------------------*/
return (
    <div className="app container py-4">
      {/* Header */}
      <header className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h3">DJ ILL'N Library</h1>
        <Button variant="outline-danger" onClick={handleLogout}>
          Sign Out
        </Button>
      </header>

      <div className="row">
        {/* Folders sidebar */}
<div className="mb-3">
  <label className="form-label text-light">Select Folder</label>
  <select
    className="form-select bg-dark text-light border-secondary"
    value={folder}
    onChange={(e) => openFolder(e.target.value)}
  >
    <option value="">— Choose a folder —</option>
    {folders.map((f) => (
      <option key={f} value={f}>
        {f}
      </option>
    ))}
  </select>
</div>

        {/* Files list and search */}
<div className="w-100">
  <h5 className="mb-3">{folder}</h5>

  <input
    className="form-control mb-3"
    placeholder="Search in folder..."
    value={query}
    onChange={(e) => setQuery(e.target.value)}
  />

  <div className="list-group files-list w-100">
    {filteredFiles().map((file, i) => (
      <button
        key={file}
        className={`list-group-item list-group-item-action w-100 d-flex justify-content-between align-items-center ${
          queue[playingIndex] === file ? "active" : ""
        }`}
        onClick={() => handleFileClick(i)}
      >
        {file}
        {queue[playingIndex] === file && <span>▶</span>}
      </button>
    ))}
  </div>
</div>
      </div>



{/* Sticky player */}
<div className="sticky-player p-3 border-top shadow-sm">
  {/* Audio player row */}
  <audio
    ref={audioRef}
    controls
    controlsList="nodownload"
    onEnded={onEnded}
    className="w-100 mb-2"
  />

  {/* Controls + now playing row */}
  <div className="d-flex align-items-center justify-content-between gap-3">
    {/* Transport buttons */}
    <div className="d-flex align-items-center gap-2 flex-nowrap">
      <Button size="sm" variant="secondary" onClick={playPrevious} disabled={history.length === 0}>
        ⏮
      </Button>

      <Button
        size="sm"
        variant={shuffle ? "warning" : "secondary"}
        onClick={toggleShuffle}
      >
        🔀
      </Button>

      <Button size="sm" variant="secondary" onClick={playNext}>
        ⏭
      </Button>
    </div>

    {/* Now playing */}
<div className="now-playing" ref={nowPlayingRef}>
  <div
    className={`now-playing-track ${scrollTitle ? "scrolling" : ""}`}
    ref={trackRef}
  >
    <span>{playingIndex >= 0 ? queue[playingIndex] : "—"}</span>

    {scrollTitle && (
      <>
        <span className="spacer"> • </span>
        <span>{playingIndex >= 0 ? queue[playingIndex] : "—"}</span>
      </>
    )}
  </div>
</div>

  </div>
</div>



    </div>
  );
};

export default App;
